module.exports = __webpack_public_path__ + "static/media/stripe_mastercard.94b41a4b.svg";